<template>
  <div>
    <v-autocomplete
      hide-details
      :placeholder="placeText"
      :items="muhasebeItems"
      item-text="Text"
      item-value="CodeID"
      :label="text"
      :disabled="aktifmi"
      v-model="val"
      return-object
     
      clearable
      id="searchAnaKod"
      :rules="rule"
      :search-input.sync="searchMuhasebeKod"
    >
      <template v-slot:append-outer>
        <v-icon color="info" @click="openDialog()">search</v-icon>
      </template>
      <template v-slot:selection="data">
        <span class="teksatir" v-if="data.item.Code != 0">
          {{ data.item.Code }} - {{ data.item.CodeName }}
        </span>
      </template>
      <template v-slot:item="data">
        <v-layout row wrap pa-1>
          <v-flex xs10 sm10 md6>
            <v-layout row wrap>
              <v-flex xs10 sm10 md12>
                <span class="subheading font-weight-medium">
                  {{ $t("Accounting-Code") }}
                </span>
              </v-flex>
              <v-flex xs10 sm10 md12>
                <span class="body-1" v-html="data.item.Code"> </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm10 md6>
            <v-layout row wrap>
              <v-flex xs10 sm10 md12>
                <span class="subheading font-weight-medium">
                  {{ $t("Accounting-Name") }}
                </span>
              </v-flex>
              <v-flex xs10 sm10 md12>
                <span class="body-1" v-html="data.item.CodeName"> </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </v-autocomplete>

    <v-layout row justify-center>
      <v-dialog v-model="searchDialog" persistent>
        <v-card>
          <v-card-text>
            
            <hesapkoduara
              ref="hesapkoduAra"
              @closeSearchData="setHesapKodu($event)"
              :isCoper="Coper"
            ></hesapkoduara>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="searchDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import auth from "@/api/auth";
import hesapkoduara from "@/components/app/muhasebe/comp/hesapkoduara.vue";

export default {
  props: {
    value: {},
    aktifmi: {
      type: Boolean,
    },
    islem: {
      type: String,
    },
    controlValue: {},
    companyID: {},
    zorunlumu: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
    rules: {
      type: Array,
    },
    Coper:{
      type:Boolean,
      default:false
    },
  
  },
  methods: {
    getList(val){
      this.$refs.hesapkoduAra.getListCoperDate(val);
    },
    openDialog() {
      this.searchDialog = true;
    },
    setHesapKodu(element) {
      var newItem = {
        CodeID: element.CodeID,
        CompanyID: element.CompanyID,
        Code: element.Code,
        CodeName: element.CodeName,
        Text: element.Code + "-" + element.CodeName,
      };
      this.val = newItem;
      this.searchDialog = false;
    },
    controlText() {
      if (document.getElementById("searchAnaKod").value.length > 0) {
        var params = {
          UserID: this.credentials.UserID,
          CodeID: 0,
          CompanyID: this.companyID,
          Code: document.getElementById("searchAnaKod").value.trim(),
          SearchText: null,
        };

        this.$http
          .post(
            auth.API_URL + "api/AccountingCodes/AccountingCodeLoad",
            params,
            {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            }
          )
          .then(
            (response) => {
              if (response.body.CodeID == 0) {
                this.placeText = "Hatalı Kod..";
                this.$emit("validateCheck");
                this.muhasebeItems = [];
              } else {
                var result = {
                  CodeID: 0,
                  CompanyID: 0,
                  Code: response.body.Code,
                  CodeName: response.body.CodeName,
                  Text: response.body.Code + "-" + response.body.CodeName,
                };
                this.muhasebeItems = [result];
                this.placeText = null;
              }
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-AccountingCodeLoad";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-AccountingCodeLoad";
                this.snackbar = true;
              }
            }
          );
      }
    },
    SearchCode(value) {
        if (this.loading==true)
        {
            return;
        }
        this.loading = true
        this.muhasebeItems = [];
        var params = {
          UserID: 0,
          CodeID: 0,
          CompanyID: this.credentials.MuhasebeSirketNo,
          Code: null,
          SearchText: value,
          BalanceShow: false,
        };
        this.$http
          .post(
            auth.API_URL + "api/AccountingCodes/AccountingCodeSearch",
            params,
            {
              headers: {
                Authorization: "Bearer " + auth.getAuthHeader(),
              },
            }
          )
          .then(
            (response) => {
              for (let index = 0; index < response.body.length; index++) {
                const element = response.body[index];
                this.muhasebeItems.push({
                  CodeID: element.CodeID,
                  CompanyID: element.CompanyID,
                  Code: element.Code,
                  CodeName: element.CodeName,
                  Text: element.Code + "-" + element.CodeName,
                });
               
              }
              this.loading = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-AccountingCodeSearch";
                this.snackbar = true;
                this.loading = false;
              } else {
                this.text1 = "Service Unavailable-AccountingCodeSearch";
                this.snackbar = true;
                this.loading = false;
              }
            }
          );
      },
  },
  computed: {
    val: {
      get: function () {
        var tip = typeof this.value;
        if (tip == "object" && this.value.CodeID != 0) {
          var r = {
            CodeID: this.value.CodeID,
            CompanyID: this.value.CodeID,
            Code: this.value.Code,
            CodeName: this.value.CodeName,
            Text: this.value.Code + "-" + this.value.CodeName,
          };
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.muhasebeItems = [r];
          return r;
        } else {
          return this.value;
        }
      },
      set: function (newValue) {
        if (newValue == null) {
          newValue = { CodeID: 0, CompanyID: 0, Code: null, CodeName: null };
        }
        this.$emit("input", newValue);
      },
    },
  },
  components:{
    hesapkoduara
  },
  data() {
    return {
      searchDialog: false,
      rule: [],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      muhasebeItems: [],
      placeText: null,
      searchMuhasebeKod: "",
      counter: 0,
      loading: false,
    };
  },
  watch: {
    aktifmi() {
      if (this.aktifmi) {
        this.value = { CodeID: 0, CompanyID: 0, Code: null, CodeName: null };
      }
    },
    searchMuhasebeKod(val) {
      val && this.SearchCode(val);
    },
  },
};
</script>

<style scoped>
.teksatir {
    overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 220px;
}
</style>